import * as helpers from '../../js/helpers';

export default function initStratisMenu() {
    const nav = document.querySelector('.stratis-menu');

    if (nav === null) {
        return;
    }

    const outsideToggle = document.querySelector('.stratis-menu-trigger');
    const menu = nav.querySelector('.stratis-menu__list');
    const toggleBtn = [].slice.call(menu.querySelectorAll('.stratis-menu__toggle'));
    const a11yReport = document.querySelector('.a11y-report');
    const toogleReport = menu.querySelector('.stratis-menu__toggle-report');

    const openMenu = (event) => {
        const element = event.target;
        const parent = element.tagName.toLowerCase() === 'button'
            ? element.parentElement
            : element.parentElement.parentElement;

        const ariaToggle = element.tagName.toLowerCase() === 'button'
            ? element
            : element.parentElement;
        const ariaTarget = parent.querySelector('.stratis-menu__submenu');

        const listItems = element.tagName.toLowerCase() === 'button'
            ? element.parentElement.parentElement.querySelectorAll('.stratis-menu__item')
            : element.parentElement.parentElement.parentElement.querySelectorAll('.stratis-menu__item');

        for (let i = 0; i < listItems.length; i++) {
            helpers.removeClass(listItems[i], '-is-active');
        }

        helpers.addClass(parent, '-is-active');
        helpers.setAriaControls(ariaToggle, ariaTarget, 'opened');
    };

    const closeMenu = (event) => {
        const element = event.target;

        const ariaToggle = element.tagName.toLowerCase() === 'button'
            ? element
            : element.parentElement;
        const parent = element.tagName.toLowerCase() === 'button'
            ? element.parentElement
            : element.parentElement.parentElement;
        const ariaTarget = parent.querySelector('.stratis-menu__submenu');

        const listItems = element.tagName.toLowerCase() === 'button'
            ? element.parentElement.parentElement.querySelectorAll('.stratis-menu__item')
            : element.parentElement.parentElement.parentElement.querySelectorAll('.stratis-menu__item');

        for (let i = 0; i < listItems.length; i++) {
            helpers.removeClass(listItems[i], '-is-active');
        }
        helpers.setAriaControls(ariaToggle, ariaTarget, 'closed');
    };

    const manageMenu = (event) => {
        const element = event.target;
        const parent = element.tagName.toLowerCase() === 'button'
            ? element.parentElement
            : element.parentElement.parentElement;

        if (helpers.hasClass(parent, '-is-active')) {
            closeMenu(event);
        } else {
            openMenu(event);
        }
    };

    outsideToggle.addEventListener('click', () => {
        const state = helpers.hasClass(nav, '-is-visible')
            ? helpers.removeClass(nav, '-is-visible')
            : helpers.addClass(nav, '-is-visible');
        if (a11yReport && helpers.hasClass(a11yReport, '-is-visible')) {
            helpers.removeClass(a11yReport, '-is-visible');
        }
    });

    toggleBtn.forEach((elem) => {
        const submenu = elem.parentElement.querySelector('.stratis-menu__submenu');
        helpers.initAriaControls(elem, submenu);
        elem.addEventListener('click', (e) => {
            manageMenu(e);
        });
    });

    if (toogleReport) {
        toogleReport.addEventListener('click', () => {
            if (a11yReport) {
                const state = helpers.hasClass(a11yReport, '-is-visible')
                    ? helpers.removeClass(a11yReport, '-is-visible')
                    : helpers.addClass(a11yReport, '-is-visible');
            }
        });
    }

    document.addEventListener('click', (event) => {
        const isClickInside = nav.contains(event.target);
        const activeElement = menu.querySelector('.stratis-menu__item.-is-active .stratis-menu__toggle');
        if (!isClickInside && activeElement !== null) {
            activeElement.click();
        }
    });
}
